const ProductPage = function() {
    const variantPartsCache = new WeakMap();
    function variantData(option) {
        const title = option.text;
        let data = variantPartsCache.get(option);
        if (!data || data.title !== title) {
            const parts = title.split(' / ');
            data = { title, parts, sortedParts: parts.slice().sort() };
            variantPartsCache.set(option, data);
        }
        return data;
    }
    function ProductPage() {
        this.selector = {
            productForm: document.getElementById('data-product-form'),
            fitGuideModalContainers: document.querySelectorAll('.fit-guide-modal .component-modal .modal .modal__content .modal__div'),
            fitGuideModalToggle: document.querySelector('.fit-guide-modal .component-modal .modal-toggle'),
            preSelectedInput: document.querySelectorAll('input[data-single-option-selector]:checked'),
            fitGuideModalClose: document.querySelectorAll('.fit-guide-modal .component-modal .modal .modal__content .modal__close'),
            sizeGuideModalContainers: document.querySelectorAll('.size-guide-modal .component-modal .modal .modal__content .modal__div'),
            sizeGuideModalToggle: document.querySelector('.size-guide-modal .component-modal .modal-toggle'),
            sizeGuideModalClose: document.querySelectorAll('.size-guide-modal .component-modal .modal .modal__content .modal__close'),
            cartdraweritemcount: document.getElementById('cart-drawer-item-count'),
            cartcountbubble: document.getElementById('cart-count-bubble'),
            formcartdrawer: document.getElementById('form-cart-drawer'),
            cartdrawer: document.getElementById('cart-drawer'),
            cartdraweroverlay: document.getElementById('cart-drawer-overlay'),
            mainquickmodalview: document.getElementById('quick-view-modal'),
            productTabsHeading: document.querySelectorAll('.product-tabs .accordion-tabs .accordion-tabs-headings .accordion-tabs-item'),
            productTabsDescription: document.querySelectorAll('.product-tabs .accordion-tabs .accordion-tabs-content'),
            swiper: document.querySelector('.featured-image-slider .product-gallery-swiper'),
            productTabsToggle: document.querySelectorAll('.product-tabs .accordion-tabs .accordion-tabs-toggle'),
            zoomContainer: document.querySelectorAll('.featured-image-slider-container .featured-image-slider .swiper-zoom-container'),
        }
        this.state = {
            swiper: null,
            rendered: false,
            editMode: false,
            currentActive: null
        }
        this.load();
    }
    ProductPage.prototype.load = function() {
        var _ = this;
        if(_.selector.swiper) {
                /* On mobile, omit the navigation config so Swiper does not own
                   the prev/next buttons. Without a navigation owner Swiper does
                   not set inline display on the buttons, and the CSS hide rule
                   in component-product-page.css (@media max-width:768px) wins.
                   The .swiper-button-prev/next divs remain in markup for desktop
                   only — desktop matches the previous behaviour exactly.
                   Reason: iOS Safari users (29.7% of traffic) were still seeing
                   the arrows on every PDP gallery, eating tap area next to the
                   colour swatches — confirmed across multiple Clarity sessions
                   on 2.2 theme (2026-05-17). */
                /* T6.32c (19 Sep 2026): was 1023px. The product page keeps its desktop
                   two-column layout (and the gallery arrows) down to 1000px now. */
                var isMobile = window.matchMedia('(max-width: 999.98px)').matches;
                var swiperOpts = {
                    zoom: true,
                    direction: 'horizontal',
                    slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    initialSlide: parseInt(_.selector.swiper.dataset.defaultSlideIndex)
                };
                if (!isMobile) {
                    swiperOpts.navigation = {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    };
                } else {
                    /* Remove the .slider-controls wrapper (which contains both
                       arrows) on mobile so nothing renders even if a CSS rule
                       fails. The arrows are siblings of .product-gallery-swiper
                       inside .featured-image-slider — the previous selector
                       was wrong, so nothing was actually being removed. */
                    var sliderControls = document.querySelector('.featured-image-slider .slider-controls');
                    if (sliderControls) sliderControls.remove();
                }
                _.state.swiper = new Swiper(`${_.selector.swiper.dataset.selectorName}`, swiperOpts);
                _.state.swiper.on('click', function(swiper) {
                    const zoom = swiper.zoom;
                    if(zoom.scale === 1) {
                        zoom.in();
                    } else {
                        zoom.out();
                    }
                })
                _.initGalleryThumbs();
        }
        if(_.selector.fitGuideModalToggle) {
            _.selector.fitGuideModalToggle.addEventListener('click', event => {
                event.target.closest('.component-modal').querySelector('.modal').classList.toggle('open');
            })
        }
        if(_.selector.sizeGuideModalToggle) {
            _.selector.sizeGuideModalToggle.addEventListener('click', event => {
                event.target.closest('.component-modal').querySelector('.modal').classList.toggle('open');
            })
        }
        if(_.selector.preSelectedInput.length > 0) {
            Array.from(_.selector.preSelectedInput).map(input => {
                if(input.dataset.optionName ==='Fit' && input.checked) {
                    Array.from(_.selector.fitGuideModalContainers).map(container => {
                        const inputValue = input.value.toLowerCase().replaceAll('-', '').replaceAll(' ', '');
                        const dataseFit = container.dataset.fit.toLowerCase().replaceAll('-','').replaceAll(' ','');
                        if(dataseFit === inputValue) {
                            container.classList.add('active');
                        } else {
                            container.classList.remove('active');
                        }
                    })
                    Array.from(_.selector.sizeGuideModalContainers).map(container => {                      
                        const inputValue = input.value.toLowerCase().replaceAll('-', '').replaceAll(' ', '');
                        const dataseSize = container.dataset.size.toLowerCase().replaceAll('-','').replaceAll(' ','');
                        if(dataseSize === inputValue) {
                            container.classList.add('active');
                        } else {
                            container.classList.remove('active');
                        }
                    })
                }
            })
        }
        if(_.selector.productForm) {
            _.selector.productForm.addEventListener("click", event => {
                if(event.target.closest('label.option-value')) {
                    const currentUrl = window.location.href;
                    let addToCart = true;
                    const inputSelected = document.getElementById(`${event.target.closest('label.option-value').getAttribute('for')}`);
                    inputSelected.checked = true;
                    const variantWrapper = event.target.closest('.variant-wrapper');
                    const variantOptionsSelectedInput = variantWrapper.querySelectorAll('input[data-single-option-selector]:checked');
                    const variantOptionsSelectedSelect = variantWrapper.querySelector('select[data-single-option-selector]');
                    const variantOptionsFit = [];
                    const variantOptionsSize = [];

                    // Perf hoist (T1.4 audit 20MAY2026): cache repeated DOM lookups
                    // outside the variant loop. Previously these were queried inside
                    // the loop body (150x per click on flagship tees).
                    const formEl = event.target.closest('form');
                    /* T5.32c (25 May 2026) — Reverted to querySelector (single).
                       The above-pickers price block was removed per user feedback,
                       so there's only one .convx__product-price element again
                       (inside the ATC button). The forEach writes below still
                       work correctly on a 1-element NodeList — kept for resilience
                       in case the visible price block is re-added later. */
                    const priceEl = formEl && formEl.querySelectorAll('.convx__product-price');
                    const priceCompareEl = formEl && formEl.querySelectorAll('.convx__product-price-compare-at');
                    const addToCartBtn = _.selector.productForm.querySelector('.add-to-cart');
                    const addToCartText = addToCartBtn && addToCartBtn.querySelector('[data-add-to-cart-text]');

                    if(variantOptionsSelectedSelect) {
                        const productSelectVariants = _.selector.productForm.querySelector('select[name="id"]');
                        const urlObject = new URL(currentUrl);
                        const selectedSelectValue = variantOptionsSelectedSelect.options[variantOptionsSelectedSelect.selectedIndex].value;
                        let colourMatched = false;
                        Array.from(productSelectVariants.options).forEach(option => {
                            const optionTextSplit = variantData(option).parts;
                            if(inputSelected.dataset.optionName === 'Size' && optionTextSplit[optionTextSplit.length - 1] === inputSelected.value && optionTextSplit.includes(selectedSelectValue)) {
                                if(option.dataset.available === 'true') {
                                    const ImageSelected = document.getElementById(option.dataset.imageId);
                                    ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                    urlObject.searchParams.set('variant', option.value);
                                    window.history.replaceState(null, document.title, urlObject.toString());
                                    if (addToCartBtn) addToCartBtn.disabled = !addToCart;
                                    if (addToCartText) addToCartText.textContent = 'Add to Cart';
                                    if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                    if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                    option.selected = true;
                                } else {
                                    option.selected = false;
                                }
                            }
                            /* T5.31 (25 May 2026) — Position-agnostic Colour match.
                               Was `optionTextSplit[0] === inputSelected.value` which
                               assumed Colour is option1 in the variant title. True for
                               tees ("Black / Small") but FALSE for hats ("Bucket Hat /
                               Black"), so clicking a Colour swatch on any product whose
                               Colour is not the first option was a silent no-op. Using
                               includes() is unique because the same condition already
                               requires the selectedSelectValue (Style/Fit) to be present,
                               so "Black" + "Bucket Hat" picks exactly "Bucket Hat / Black".
                               For tees, "Black" + "Small" picks exactly "Black / Small". */
                            if(inputSelected.dataset.optionName === 'Colour' && optionTextSplit.includes(inputSelected.value) && optionTextSplit.includes(selectedSelectValue)) {
                                colourMatched = true;
                                if(option.dataset.available === 'true') {
                                    const ImageSelected = document.getElementById(option.dataset.imageId);
                                    ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                    urlObject.searchParams.set('variant', option.value);
                                    window.history.replaceState(null, document.title, urlObject.toString());
                                    if (addToCartBtn) addToCartBtn.disabled = !addToCart;
                                    if (addToCartText) addToCartText.textContent = 'Add to Cart';
                                    if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                    if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                    option.selected = true;
                                } else {
                                    option.selected = false;
                                }
                            }
                        })

                        /* T5.36o (26 May 2026) — Hat colour-strands-style auto-switch.
                           When the picked Colour doesn't exist with the current Style/Fit
                           (e.g. on hats where "Bucket Hat" doesn't come in "Sand"), the
                           loop above finds no match → colourMatched stays false → image,
                           price, URL all stale. Previously the user was stranded. Now:
                           find the FIRST available variant containing the new colour,
                           switch the Style/Fit dropdown to that variant's Style, and
                           re-fire the change so the image + price update correctly.
                           Only applies to the Colour click path — Size + native click
                           paths are unaffected. */
                        if (inputSelected.dataset.optionName === 'Colour' && !colourMatched) {
                            const fallbackVariant = Array.from(productSelectVariants.options).find(opt =>
                                opt.dataset.available === 'true' &&
                                variantData(opt).parts.includes(inputSelected.value)
                            );
                            if (fallbackVariant) {
                                const fallbackParts = variantData(fallbackVariant).parts;
                                /* The Style/Fit value is whichever part of the variant
                                   title that ISN'T the colour we just clicked. With 2-option
                                   products this is unambiguous. */
                                const newStyleValue = fallbackParts.find(part => part !== inputSelected.value);
                                if (newStyleValue) {
                                    /* Switch the dropdown to the new Style and dispatch
                                       change so all dependent UI (sizes, etc.) updates. */
                                    Array.from(variantOptionsSelectedSelect.options).forEach(opt => {
                                        if (opt.value === newStyleValue) opt.selected = true;
                                    });
                                    variantOptionsSelectedSelect.dispatchEvent(new Event('change', { bubbles: true }));
                                    /* Update price/image/URL to the fallback variant inline. */
                                    const ImageSelected = document.getElementById(fallbackVariant.dataset.imageId);
                                    ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                    urlObject.searchParams.set('variant', fallbackVariant.value);
                                    window.history.replaceState(null, document.title, urlObject.toString());
                                    if (addToCartBtn) addToCartBtn.disabled = false;
                                    if (addToCartText) addToCartText.textContent = 'Add to Cart';
                                    if (priceEl) priceEl.forEach(el => el.textContent = fallbackVariant.dataset.regularPrice);
                                    if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = fallbackVariant.dataset.compareAtPrice);
                                    fallbackVariant.selected = true;
                                }
                            }
                        }
                        return;
                    }

                    // Build variantOptionsFit / variantOptionsSize from checked inputs
                    // (kept O(small) — only iterates checked inputs, not all variants).
                    Array.from(variantOptionsSelectedInput).forEach(option => {
                        if(option.dataset.optionName === 'Colour' && option.checked) {
                            variantOptionsFit.push(option.value);
                        }
                        if(option.dataset.optionName === 'Colour' && option.checked || option.dataset.optionName ==='Fit' && option.checked) {
                            variantOptionsSize.push(option.value);
                        }
                    })

                    // Guide-modal updates (T1.5 audit 20MAY2026): only run when the
                    // user actually clicked a Fit or Style input. Previously this
                    // ran on EVERY variant click (Colour, Size, anything) because
                    // it iterated all checked inputs and re-checked the Fit one each
                    // time. ~5-15ms saved per Colour/Size click.
                    if(inputSelected.dataset.optionName === 'Fit' || inputSelected.dataset.optionName === 'Style') {
                        const fitValue = inputSelected.value;
                        const fitValueNormalised = fitValue.toLowerCase().replaceAll('-', '').replaceAll(' ', '');
                        Array.from(_.selector.fitGuideModalContainers).forEach(container => {
                            const datasetFit = container.dataset.fit.toLowerCase().replaceAll('-', '').replaceAll(' ', '');
                            if(fitValueNormalised === datasetFit) {
                                container.classList.add('active');
                            } else {
                                container.classList.remove('active');
                            }
                        })
                        Array.from(_.selector.sizeGuideModalContainers).forEach(container => {
                            const datasetSize = container.dataset.size.toLowerCase().replaceAll('-','').replaceAll(' ','');
                            if(datasetSize === fitValueNormalised) {
                                container.classList.add('active');
                            } else {
                                container.classList.remove('active');
                            }
                        })
                    }
                    const optionValuesAvailable = [];
                    const selectedVariantOptions = [];
                    const productOptionInputs = _.selector.productForm.querySelectorAll('input[data-single-option-selector]');
                    const productSelectVariants = _.selector.productForm.querySelector('select[name="id"]');
                    const optionSelected = [];
                    if(productOptionInputs.length > 0) {
                        Array.from(productOptionInputs).map(option => {
                            option.setAttribute('disabled', true);
                            if(option.checked) {
                                selectedVariantOptions.push(option);
                                optionSelected.push(option.value);
                            }                            
                        })
                    }
                    if (productSelectVariants) {
                        const sortedSelectedOptions = optionSelected.slice().sort();
                        let hitMatched = false;
                        Array.from(productSelectVariants.options).forEach(option => {
                                const optionTextSplit = variantData(option).parts;
                                const optionFoundFit = variantOptionsFit.every(optValue => optionTextSplit.includes(optValue));
                                const optionFoundSize = variantOptionsSize.every(optValue => optionTextSplit.includes(optValue));
                                if(optionFoundFit) {
                                    const setAvailableFit = optionTextSplit.filter(availableValue => !variantOptionsFit.includes(availableValue));
                                    if(!optionValuesAvailable.includes(setAvailableFit[0])) {
                                        optionValuesAvailable.push(setAvailableFit[0]);
                                    }
                                }
                                if(optionFoundSize) {
                                    const setAvailableSize = optionTextSplit.filter(availableValue => !variantOptionsSize.includes(availableValue));
                                    if(!optionValuesAvailable.includes(setAvailableSize[0])) {
                                        optionValuesAvailable.push(setAvailableSize[0]);
                                    }
                                }
                                let allValuesMeetCondition = true;
                                if (optionSelected.length > 0) {
                                    allValuesMeetCondition = variantData(option).sortedParts.every((value, index) => value === sortedSelectedOptions[index]);
                                }
                                addToCart = option.dataset.available === "true" ? true : false;
                                if(allValuesMeetCondition) {
                                    option.selected = true;
                                    hitMatched = true;
                                    const ImageSelected = document.getElementById(option.dataset.imageId);
                                    ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                    const urlObject = new URL(currentUrl);
                                    urlObject.searchParams.set('variant', option.value);
                                    window.history.replaceState(null, document.title, urlObject.toString());
                                    // Perf hoist (T1.4): priceEl / priceCompareEl cached above
                                    if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                    if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                } else {
                                    option.selected = false;
                                }
                        });
                        /* T5.36q — Reverted T5.36m .context-unavailable split.
                           User preferred the original strikethrough/diagonal-
                           stripe treatment ("much clearer"). Restoring the
                           single .unavailable class for both true sold-out
                           and fit-dependent unavailable. */
                        Array.from(productOptionInputs).map(el => {
                            if(!optionValuesAvailable.includes(el.value) && el.dataset.optionName !== 'Colour') {
                                el.setAttribute('disabled', true);
                                el.classList.add('unavailable');
                            } else {
                                el.removeAttribute('disabled');
                                el.classList.remove('unavailable');
                            }
                        })
                        if(!hitMatched) {
                        const productForm = _.selector.productForm;
                        const productOptionInputSelected = productForm.querySelectorAll('input[data-single-option-selector]:checked');
                        const productOptionsInputs = productForm.querySelectorAll('input[data-single-option-selector]');
                        const productSelectVariants = productForm.querySelector('select[name="id"]');

                        const optionSizes = [];

                        if (productOptionInputSelected.length > 0) {
                            Array.from(productOptionInputSelected).forEach(input => {
                                if (input.disabled) {
                                    const productOptionsName = Array.from(productOptionsInputs).find(option => option.dataset.optionName === input.dataset.optionName && !option.disabled);

                                    if (productOptionsName) {
                                        productOptionsName.checked = true;
                                        /* T5.32e (25 May 2026) — Sync the "Option · Value" label
                                           span after programmatic .checked. Without this, the user
                                           clicks a colour that strands the current Fit (or Size);
                                           the fallback auto-picks a different Fit, but the
                                           "Fit · Regular" label still says the old value because
                                           programmatic .checked doesn't fire 'change' events
                                           (which the IIFE near the bottom of this file uses to
                                           keep the spans in sync). Mirrors the same span-sync I
                                           added at T5.31b for the select-dropdown fallback. */
                                        if (productOptionsName.dataset.optionName) {
                                            var syncSpans = document.querySelectorAll('.option-selected-value[data-for-option="' + productOptionsName.dataset.optionName + '"]');
                                            syncSpans.forEach(function(span) {
                                                span.textContent = String(productOptionsName.value);
                                                span.removeAttribute('hidden');
                                                var sep = span.previousElementSibling;
                                                if (sep && sep.classList && sep.classList.contains('lkc-pdp-picker-label__sep')) {
                                                    sep.removeAttribute('hidden');
                                                }
                                            });
                                        }
                                    }

                                    if (input.dataset.optionName === 'Fit') {
                                        Array.from(productSelectVariants.options).forEach(option => {
                                            if (option.text.includes(productOptionInputSelected[0].value) &&
                                                option.text.includes(productOptionsName.value) &&
                                                option.dataset.available === 'true') {
                                                    const optionText = variantData(option).parts;
                                                    optionSizes.push(optionText[optionText.length - 1]);
                                            }
                                        });

                                        optionSizes.forEach(size => {
                                            Array.from(productOptionsInputs).forEach(input => {
                                                if (size === input.value) {
                                                    input.disabled = false;
                                                    input.classList.remove('unavailable');
                                                }
                                            });
                                        });
                                    }
                                }
                            });

                            const finalOptionInputSelected = productForm.querySelectorAll('input[data-single-option-selector]:checked');
                            const finalSelectedValue = Array.from(finalOptionInputSelected).map(option => option.value);

                                Array.from(productSelectVariants.options).forEach(option => {
                                    const optionText = variantData(option).parts;
                                    option.selected = false;

                                    const allMatch = optionText.every((text, index) => text === finalSelectedValue[index]);

                                    if (allMatch) {
                                        option.selected = true;
                                        const ImageSelected = document.getElementById(option.dataset.imageId);
                                        if (ImageSelected) {
                                            _.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100);
                                        }

                                        const urlObject = new URL(window.location.href);
                                        urlObject.searchParams.set('variant', option.value);
                                        window.history.replaceState(null, document.title, urlObject.toString());
                                        // Perf hoist (T1.4): priceEl / priceCompareEl cached at top of handler. T5.32: forEach.
                                        if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                        if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                    }
                                });
                            }                 
                        }
                    }
                }
                if(event.target.closest('.convx__stock-msg-toggle-btn')) {
                    if(event.target.closest('.stock-msg-modal')) {
                        if(event.target.closest('.stock-msg-modal') && event.target.closest('.stock-msg-modal').querySelector('.stock-message').dataset.autoloadSnippet === 'stock-message') {
                            event.target.closest('.stock-msg-modal').querySelector('.stock-message').classList.add('in-stock');
                        }
                        event.target.closest('.stock-msg-modal').querySelector('.modal').classList.add('open');
                    }
                }
                if(event.target.closest('.modal__close')) {
                    event.target.closest('.stock-msg-modal') && event.target.closest('.stock-msg-modal').querySelector('.modal').classList.remove('open');
                }           
            })
            _.selector.productForm.addEventListener('change', event => {
                if(event.target.closest('select')) {
                    let hitMatched = false;
                    const currentUrl = window.location.href;
                    const productSelectVariants = _.selector.productForm.querySelector('select[name="id"]');
                    const productOptionInputs = _.selector.productForm.querySelectorAll('input[data-single-option-selector]');
                    const optionValuesAvailable = [];
                    const variantOptionsSize = [];

                    // Perf hoist (T1.4 audit 20MAY2026): cache DOM lookups outside the variant loop
                    const formEl = event.target.closest('form');
                    /* T5.32c (25 May 2026) — Reverted to querySelector (single).
                       The above-pickers price block was removed per user feedback,
                       so there's only one .convx__product-price element again
                       (inside the ATC button). The forEach writes below still
                       work correctly on a 1-element NodeList — kept for resilience
                       in case the visible price block is re-added later. */
                    const priceEl = formEl && formEl.querySelectorAll('.convx__product-price');
                    const priceCompareEl = formEl && formEl.querySelectorAll('.convx__product-price-compare-at');
                    const variantWrapper = event.target.closest('.variant-wrapper');
                    const changedValueNormalised = event.target.value.toLowerCase().replaceAll('-', '').replaceAll(' ', '');

                    Array.from(productOptionInputs).forEach(option => {
                        if(option.dataset.optionName === 'Size') {
                            variantOptionsSize.push(option);
                        }
                    })
                    Array.from(_.selector.fitGuideModalContainers).forEach(container => {
                        const datasetFit = container.dataset.fit.toLowerCase().replaceAll('-', '').replaceAll(' ', '');
                        if(changedValueNormalised === datasetFit) {
                            container.classList.add('active');
                        } else {
                            container.classList.remove('active');
                        }
                    })
                    Array.from(_.selector.sizeGuideModalContainers).forEach(container => {
                        const datasetSize = container.dataset.size.toLowerCase().replaceAll('-','').replaceAll(' ','');
                        if(datasetSize === changedValueNormalised) {
                            container.classList.add('active');
                        } else {
                            container.classList.remove('active');
                        }
                    })

                    const variantSizeSelectedInput = variantWrapper && variantWrapper.querySelector('input[data-single-option-selector]:checked');
                    const selectedDropdownValue = event.target.options && event.target.options.length > 0
                        ? event.target.options[event.target.selectedIndex].value
                        : null;
                    Array.from(productSelectVariants.options).forEach(option => {
                        // T3.1: use cached split (built once at init) for ~30% faster per-iteration cost
                        const optionTextSplit = variantData(option).parts;
                        if(option.dataset.available === 'true' && optionTextSplit.includes(event.target.value)) {
                            optionValuesAvailable.push(optionTextSplit[optionTextSplit.length - 1]);
                        }
                        if(variantSizeSelectedInput && selectedDropdownValue && optionTextSplit.includes(selectedDropdownValue) && optionTextSplit.includes(variantSizeSelectedInput.value) && option.dataset.available === 'true') {
                            option.selected = true;
                            const ImageSelected = document.getElementById(option.dataset.imageId);
                            ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                            let urlObject = new URL(currentUrl);
                            urlObject.searchParams.set('variant', option.value);
                            window.history.replaceState(null, document.title, urlObject.toString());
                            hitMatched = true;
                            if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                            if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                        }
                    })
                    Array.from(productOptionInputs).map(option => {
                        /* T5.36q — Reverted T5.36m, restoring original .unavailable. */
                        if(optionValuesAvailable.includes(option.value)) {
                            option.classList.remove('unavailable');
                            option.removeAttribute('disabled');
                        } else {
                            option.classList.add('unavailable');
                            option.setAttribute('disabled', true);
                        }
                    })
                    if(!hitMatched) {
                        const variantInputSelected = event.target.closest('.variant-wrapper').querySelector('input[data-single-option-selector]:checked');
                        if(variantInputSelected) {
                            if(variantInputSelected.disabled) {
    
                                const variantSizes = Array.from(productSelectVariants.options).find(option => option.dataset.available === 'true' && option.text.includes(event.target.value));
                                const variantInputs = event.target.closest('.variant-wrapper').querySelectorAll('input[data-single-option-selector]');
                                if(variantInputs.length > 0) {
                                    const variantSizeSplit = variantData(variantSizes).parts;
                                    Array.from(variantInputs).map(input => {
                                        if(input.value === variantSizeSplit[variantSizeSplit.length - 1]) {
                                            input.checked = true;
                                            /* T5.31b (25 May 2026) — Sync the "Select A Colour - X"
                                               span text when auto-switch fires. The IIFE at line
                                               ~833 only updates the span on user label-click or
                                               select-change — not on programmatic .checked = true,
                                               so without this the label would still say the
                                               previous colour after auto-switch. */
                                            if (input.dataset.optionName) {
                                                var lblSpans = document.querySelectorAll('.option-selected-value[data-for-option="' + input.dataset.optionName + '"]');
                                                lblSpans.forEach(function(span) {
                                                    /* T5.32 — sentence-case standalone value (matches new
                                                       picker label markup; the " · " separator is now a
                                                       separate sibling element). */
                                                    span.textContent = String(input.value);
                                                    span.removeAttribute('hidden');
                                                    var sep = span.previousElementSibling;
                                                    if (sep && sep.classList && sep.classList.contains('lkc-pdp-picker-label__sep')) {
                                                        sep.removeAttribute('hidden');
                                                    }
                                                });
                                            }
                                        } else {
                                            input.checked = false;
                                        }
                                    })
                                }
                                const fallBackSelected = variantWrapper && variantWrapper.querySelector('input[data-single-option-selector]:checked');
                                Array.from(productSelectVariants.options).forEach(option => {
                                    const optionTextSplit = variantData(option).parts;
                                    if(fallBackSelected) {
                                        if(option.dataset.available === 'true' && optionTextSplit[optionTextSplit.length - 1] === fallBackSelected.value && optionTextSplit.includes(selectedDropdownValue)) {
                                            const ImageSelected = document.getElementById(option.dataset.imageId);
                                            ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                            let urlObject = new URL(currentUrl);
                                            urlObject.searchParams.set('variant', option.value);
                                            window.history.replaceState(null, document.title, urlObject.toString());
                                            option.selected = true;
                                            if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                            if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                        }
                                    } else {
                                        if(option.dataset.available === 'true' && optionTextSplit[optionTextSplit.length - 1] === selectedDropdownValue) {
                                            const ImageSelected = document.getElementById(option.dataset.imageId);
                                            ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                            let urlObject = new URL(currentUrl);
                                            urlObject.searchParams.set('variant', option.value);
                                            window.history.replaceState(null, document.title, urlObject.toString());
                                            option.selected = true;
                                            if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                            if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                        }
                                    }
                                })

                            }
                        } else {
                            /* T5.95 (1 Jul 2026) — Preserve every non-Style axis (Colour, etc.)
                               when only the Style <select> changed. Caps have Colour swatches +
                               a Style <select> and NO checked colour radio, so the original loop
                               below dropped the colour and grabbed an arbitrary (last-available)
                               colour of the new style. Keep the current variant's values that are
                               NOT style values, add the new style, and pick that variant; only
                               fall back to the old behaviour if that combo is genuinely sold out. */
                            var _curOpt = productSelectVariants.options[productSelectVariants.selectedIndex];
                            var _newStyle = event.target.value;
                            var _styleVals = Array.from(event.target.options).map(function (o) { return o.value.trim(); });
                            var _preserve = _curOpt ? variantData(_curOpt).parts.map(function (s) { return s.trim(); }).filter(function (p) { return _styleVals.indexOf(p) === -1; }) : [];
                            var _pick = _preserve.length ? Array.from(productSelectVariants.options).find(function (o) {
                                if (o.dataset.available !== 'true') return false;
                                var t = variantData(o).parts.map(function (s) { return s.trim(); });
                                return t.indexOf(_newStyle) !== -1 && _preserve.every(function (pp) { return t.indexOf(pp) !== -1; });
                            }) : null;
                            if (_pick) {
                                var _pImg = document.getElementById(_pick.dataset.imageId);
                                _pImg && (_.state.swiper.slideTo(parseInt(_pImg.dataset.index), 100));
                                var _pUrl = new URL(currentUrl);
                                _pUrl.searchParams.set('variant', _pick.value);
                                window.history.replaceState(null, document.title, _pUrl.toString());
                                _pick.selected = true;
                                if (priceEl) priceEl.forEach(function (el) { el.textContent = _pick.dataset.regularPrice; });
                                if (priceCompareEl) priceCompareEl.forEach(function (el) { el.textContent = _pick.dataset.compareAtPrice; });
                            } else {
                                Array.from(productSelectVariants.options).forEach(option => {
                                    if(option.dataset.available === 'true' && option.text.includes(event.target.value)) {
                                        const ImageSelected = document.getElementById(option.dataset.imageId);
                                        ImageSelected && (_.state.swiper.slideTo(parseInt(ImageSelected.dataset.index), 100));
                                        let urlObject = new URL(currentUrl);
                                        urlObject.searchParams.set('variant', option.value);
                                        window.history.replaceState(null, document.title, urlObject.toString());
                                        option.selected = true;
                                        if (priceEl) priceEl.forEach(el => el.textContent = option.dataset.regularPrice);
                                        if (priceCompareEl) priceCompareEl.forEach(el => el.textContent = option.dataset.compareAtPrice);
                                    }
                                })
                            }
                        }
                    }
                }
            })
            _.selector.productForm.addEventListener('submit', event => {
                event.preventDefault();
               _.addtocart(event.target);
            })
        }
        if(_.selector.fitGuideModalClose.length > 0) {
            Array.from(_.selector.fitGuideModalClose).map(close => {
                close.addEventListener('click', event => {
                    event.target.closest('.modal').classList.remove('open');
                })
            })
        }
        if(_.selector.sizeGuideModalClose.length > 0) {
            Array.from(_.selector.sizeGuideModalClose).map(close => {
                close.addEventListener('click', event => {
                    event.target.closest('.modal').classList.remove('open');
                })
            })
        }
        if(_.selector.productTabsHeading.length > 0) {
            Array.from(_.selector.productTabsHeading).map((tab,index) => {
                if(index == 0) {
                    tab.closest('.accordion-tabs-item').classList.add('active');
                    _.selector.productTabsDescription[index].classList.add('active');
                }
                tab.addEventListener('click', event => {
                    Array.from(_.selector.productTabsHeading).map((el,idx) => {
                        el.closest('.accordion-tabs-item').classList.remove('active');
                        _.selector.productTabsDescription[idx].classList.remove('active');
                    })
                    event.target.closest('.accordion-tabs-item').classList.add('active');
                    _.selector.productTabsDescription[index].classList.add('active');
                })
            })
        }
        if(_.selector.productTabsToggle.length > 0) {
            Array.from(_.selector.productTabsToggle).map(tab => {
                tab.addEventListener('click', event => {
                    if(event.target.closest('button').getAttribute('aria-expanded') === 'false') {
                        event.target.closest('button').setAttribute('aria-expanded', 'true');
                    } else {
                        event.target.closest('button').setAttribute('aria-expanded', 'false');
                    }
                })
            })
        }
    }
    ProductPage.prototype.addtocart = async function(form) {
        if (form._lkcCartPending || form._lkcCartReviewRequired) return;
        form._lkcCartPending = true;
        const button = form.querySelector('.add-to-cart');
        const sticky = document.querySelector('.sticky-add-to-cart');
        button?.classList.add('js-loading');
        sticky?.classList.add('js-loading');
        try {
            const body = new FormData(form);
            body.set('sections', 'cart-drawer');
            const answer = await theme.CartTransactions.add(body);
            await theme.CartTransactions.render(answer);
            theme.CartTransactions.message(form, answer);
            if (answer.locked || answer.refreshFailed) {
                form._lkcCartReviewRequired = true;
                if (button) button.disabled = true;
            }
        } finally {
            form._lkcCartPending = false;
            button?.classList.remove('js-loading');
            sticky?.classList.remove('js-loading');
        }
    }
    /*
     * Mobile gallery thumbnail strip (paired with the markup in product.liquid).
     * Tap a thumb → set Colour + Fit radios to that variant's combo. Existing
     * variant-change pipeline takes care of slideTo / URL / price updates. We
     * add a needs-size-selection prompt if the user's previously-selected size
     * isn't available in the new combo (option (b) from spec).
     *
     * Hidden on desktop via CSS, so this binds harmlessly on desktop too.
     */
    ProductPage.prototype.initGalleryThumbs = function() {
        var _ = this;
        var thumbs = document.querySelectorAll('.product-gallery-thumb');
        if (!thumbs.length || !_.state.swiper) return;

        var productSelect = _.selector.productForm
            ? _.selector.productForm.querySelector('select[name="id"]')
            : null;
        if (!productSelect) return;

        function variantPartsForOption(opt) {
            // Option text format: "Colour / Fit / Size"
            return variantData(opt).parts;
        }

        function firstVariantOptionForImageId(imageId) {
            return Array.from(productSelect.options).find(function(opt) {
                return opt.dataset.imageId === imageId;
            });
        }

        function getCurrentSize() {
            var checked = document.querySelector('input[data-option-name="Size"]:checked');
            return checked ? checked.value : null;
        }

        function getSizeWrapper() {
            var sizeInput = document.querySelector('input[data-option-name="Size"]');
            return sizeInput ? sizeInput.closest('.variant-wrapper') : null;
        }

        function findVariantOption(color, fit, size) {
            return Array.from(productSelect.options).find(function(opt) {
                var parts = variantPartsForOption(opt);
                return parts[0] === color
                    && parts[1] === fit
                    && parts[2] === size
                    && opt.dataset.available === 'true';
            });
        }

        function setActiveThumb(imageId) {
            thumbs.forEach(function(t) {
                var active = t.dataset.imageId === imageId;
                t.classList.toggle('is-active', active);
                if (active) {
                    t.setAttribute('aria-selected', 'true');
                    scrollThumbIntoStrip(t);
                } else {
                    t.removeAttribute('aria-selected');
                }
            });
        }

        /*
         * Scroll the active thumb into view inside its own container only.
         * Avoids `Element.scrollIntoView`, which on desktop (where the thumb
         * column is overflow-y:auto) makes the BROWSER scroll the whole page
         * up/down to align — pulling the product image out from under the user
         * when they click an arrow or pick a colour.
         *
         * Thumbnails are a horizontal strip at all breakpoints, so we scroll
         * along X and set scrollLeft on the strip directly so the window
         * stays put.
         */
        function scrollThumbIntoStrip(thumb) {
            var strip = thumb.parentElement;
            if (!strip) return;
            // Thumbnails are a horizontal strip at every breakpoint now (below the
            // image on both mobile and desktop), so always centre the active thumb
            // along the X axis. Setting scrollLeft on the strip keeps the page put.
            var stripWidth = strip.clientWidth;
            var thumbCenter = thumb.offsetLeft + thumb.offsetWidth / 2;
            var target = Math.max(0, thumbCenter - stripWidth / 2);
            if (strip.scrollTo) {
                strip.scrollTo({ left: target, behavior: 'smooth' });
            } else {
                strip.scrollLeft = target;
            }
        }

        // When the main gallery slides (whether by swipe, color-pick, or programmatic
        // slideTo from variant change), sync the thumbnail highlight.
        _.state.swiper.on('slideChange', function() {
            var activeSlide = this.slides[this.activeIndex];
            if (activeSlide && activeSlide.id) {
                setActiveThumb(activeSlide.id);
            }
        });

        // Thumb click → set color + fit, preserve size if available
        thumbs.forEach(function(thumb) {
            thumb.addEventListener('click', function(e) {
                e.preventDefault();

                var targetOption = firstVariantOptionForImageId(thumb.dataset.imageId);

                // Images without a linked variant (design flats, lifestyle/review
                // photos, detail close-ups) should still be viewable — just slide
                // to them without changing the user's variant selection.
                if (!targetOption) {
                    _.state.swiper.slideTo(parseInt(thumb.dataset.slideIndex), 100);
                    setActiveThumb(thumb.dataset.imageId);
                    return;
                }

                var parts = variantPartsForOption(targetOption);
                var newColor = parts[0];
                var newFit = parts[1];

                var currentSize = getCurrentSize();
                var preservedMatch = currentSize ? findVariantOption(newColor, newFit, currentSize) : null;
                var sizeWrapper = getSizeWrapper();

                // Find color + fit radios
                var colorRadios = document.querySelectorAll('input[data-option-name="Colour"], input[data-option-name="Color"]');
                var fitRadios = document.querySelectorAll('input[data-option-name="Fit"]');

                // Set color radio if it needs changing — simulate label click so existing
                // variant-pipeline runs (price/url/slideTo all handled there).
                var targetColorRadio = Array.from(colorRadios).find(function(r) { return r.value === newColor; });
                var currentColor = (Array.from(colorRadios).find(function(r) { return r.checked; }) || {}).value;
                var targetFitRadio = Array.from(fitRadios).find(function(r) { return r.value === newFit; });
                var currentFit = (Array.from(fitRadios).find(function(r) { return r.checked; }) || {}).value;

                var colorLabel = targetColorRadio ? document.querySelector('label[for="' + targetColorRadio.id + '"]') : null;
                var fitLabel = targetFitRadio ? document.querySelector('label[for="' + targetFitRadio.id + '"]') : null;

                function fireFit() {
                    if (fitLabel && currentFit !== newFit) {
                        fitLabel.click();
                    }
                    // After both radios settled, check whether current size survived
                    setTimeout(function() {
                        if (!sizeWrapper) return;
                        var stillSelected = document.querySelector('input[data-option-name="Size"]:checked');
                        if (preservedMatch && stillSelected && stillSelected.value === currentSize) {
                            sizeWrapper.classList.remove('needs-size-selection');
                        } else if (currentSize && !preservedMatch) {
                            // The old size doesn't exist in the new combo → clear and prompt
                            document.querySelectorAll('input[data-option-name="Size"]:checked').forEach(function(r) {
                                r.checked = false;
                            });
                            sizeWrapper.classList.add('needs-size-selection');
                        }
                    }, 120);
                }

                if (colorLabel && currentColor !== newColor) {
                    colorLabel.click();
                    // Let existing handler settle before firing fit
                    setTimeout(fireFit, 80);
                } else {
                    fireFit();
                }

                // Visually slide swiper to this image as immediate feedback
                // (existing variant-pipeline will also call slideTo, but this is faster)
                _.state.swiper.slideTo(parseInt(thumb.dataset.slideIndex), 100);
                setActiveThumb(thumb.dataset.imageId);
            });
        });

        // Clear the needs-size prompt as soon as the user picks a size
        document.addEventListener('change', function(e) {
            if (e.target && e.target.matches && e.target.matches('input[data-option-name="Size"]')) {
                var wrap = getSizeWrapper();
                if (wrap) wrap.classList.remove('needs-size-selection');
            }
        });

        /*
         * Note: the desktop thumb column height now auto-matches the image
         * height via absolute positioning in CSS (sections/product.liquid).
         * No JS sync, no ResizeObserver, no resize listener — eliminates the
         * layout thrash that was making colour clicks feel sluggish.
         */
    };

    ProductPage = new ProductPage;
}
ProductPage();

/*
 * Append selected option value to its "Select A ___" label.
 * Markup contract: liquid renders <span class="option-selected-value"
 * data-for-option="{name}"> beside the label. This block keeps that
 * span's text in sync whenever the user picks a variant option.
 *
 * Note: we listen for CLICK on the option labels, not CHANGE on the
 * radio inputs. The theme's existing variant-change handler at the top
 * of this file sets `inputSelected.checked = true` programmatically
 * (line ~98), which does not fire a 'change' event on the input. So
 * a change listener never triggers. Click on the label always fires
 * regardless of how the existing code manages state.
 *
 * For dropdown SELECT elements, change events DO fire normally (user
 * selecting an <option> is a real input action), so we also keep a
 * change listener for selects.
 */
(function() {
    /*
     * Scope: listen ONLY on the product form, not document-wide. Previously
     * these were document-level listeners that fired on every click and
     * change anywhere on the page (Honey injections, cart drawer events,
     * etc.) before checking if it was a relevant target. Now they only
     * fire when interaction happens inside the product form.
     *
     * Capture phase (third arg = true) so the label update fires BEFORE
     * the theme's existing variant pipeline (which runs heavy O(n) loops).
     * The user sees their colour reflected in the label instantly.
     */
    /* T5.32 (25 May 2026) — Span content format changed from " - VALUE" uppercased
       to plain sentence-case value. The picker label markup in sections/product.liquid
       now provides the " · " separator as a separate sibling span; this span only
       carries the value itself. Old format would render as "Colour · - BLACK" (extra
       " - " duplicated with the new separator) so the leading characters are stripped
       and the uppercase transform is removed. */
    function updateSelectedLabel(optionName, newValue) {
        if (!optionName || newValue == null) return;
        var selector = '.option-selected-value[data-for-option="' + CSS.escape(optionName) + '"]';
        var spans = document.querySelectorAll(selector);
        spans.forEach(function(span) {
            span.textContent = String(newValue);
            span.removeAttribute('hidden');
            /* Also reveal the sibling separator span (rendered hidden when no value
               was selected at initial render). Safe no-op if the sibling structure
               isn't present (e.g. quickview or a future refactor). */
            var sep = span.previousElementSibling;
            if (sep && sep.classList && sep.classList.contains('lkc-pdp-picker-label__sep')) {
                sep.removeAttribute('hidden');
            }
        });
    }

    /* T5.32e (25 May 2026) — Sync every "Option · Value" label span to the
       actually-checked input / actually-selected dropdown option. Runs on init
       AND on a deferred rAF + 250ms tick so we catch any post-load reshuffles
       from convx.js or other init scripts that programmatically re-check
       inputs without firing 'change' events. Without this, products whose
       URL-resolved default variant isn't actually available render with a
       mismatched label (e.g. "Size · XS" while the S cell is the one
       actually selected after the auto-reshuffle). */
    function syncAllLabelsFromCurrentState() {
        var productForm = document.getElementById('data-product-form');
        if (!productForm) return;
        // Radio inputs — read the checked one per option name and write its value to the span
        var checkedRadios = productForm.querySelectorAll('input[data-single-option-selector]:checked');
        checkedRadios.forEach(function(input) {
            if (input.dataset.optionName) {
                updateSelectedLabel(input.dataset.optionName, input.value);
            }
        });
        // Select dropdowns — same idea
        var selects = productForm.querySelectorAll('select[data-single-option-selector]');
        selects.forEach(function(sel) {
            var opt = sel.options[sel.selectedIndex];
            if (!opt) return;
            updateSelectedLabel(opt.dataset.optionName || sel.dataset.optionName, sel.value);
        });
        // T5.94 — the selected variant's title (e.g. "Camouflage / Sun Hat") is the
        // true current combination; caps select Colour via the variant with no
        // :checked radio, so read the title and map each label to it (in option order).
        var esc = function (s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s; };
        var vsel = productForm.querySelector('select[name="id"]');
        if (!vsel || vsel.selectedIndex < 0 || !vsel.options[vsel.selectedIndex]) return;
        var parts = vsel.options[vsel.selectedIndex].text.split('/').map(function (s) { return s.trim(); });
        var optNames = [], seen = {};
        document.querySelectorAll('.option-selected-value[data-for-option]').forEach(function (span) {
            var n = span.getAttribute('data-for-option');
            if (n && !seen[n]) { seen[n] = 1; optNames.push(n); }
        });
        if (optNames.length === parts.length) {
            optNames.forEach(function (optName, i) { updateSelectedLabel(optName, parts[i]); });
        } else {
            optNames.forEach(function (optName) {
                var vals = {};
                productForm.querySelectorAll('input[data-option-name="' + esc(optName) + '"]').forEach(function (i) { vals[i.value] = 1; });
                productForm.querySelectorAll('select[data-single-option-selector] option[data-option-name="' + esc(optName) + '"]').forEach(function (o) { vals[o.value] = 1; });
                for (var k = 0; k < parts.length; k++) { if (vals[parts[k]]) { updateSelectedLabel(optName, parts[k]); break; } }
            });
        }
    }

    /* T5.94 — After ANY option change, the theme's variant pipeline can
       programmatically re-check a DIFFERENT option (e.g. swapping a cap's Style
       forces a new Colour) without firing a click/change on it, leaving that
       option's "Option · Value" label stale even though its swatch updated.
       Re-sync EVERY label from the real checked state once the pipeline settles. */
    function resyncAllLabelsSoon() {
        requestAnimationFrame(syncAllLabelsFromCurrentState);
        setTimeout(syncAllLabelsFromCurrentState, 80);
        setTimeout(syncAllLabelsFromCurrentState, 300);
    }

    function init() {
        var productForm = document.getElementById('data-product-form');
        if (!productForm) return;

        // Radios: listen on label clicks inside the form (existing handler
        // bypasses change events by setting .checked programmatically).
        productForm.addEventListener('click', function(e) {
            var label = e.target && e.target.closest && e.target.closest('label.option-value');
            if (!label) return;
            var inputId = label.getAttribute('for');
            if (!inputId) return;
            var input = document.getElementById(inputId);
            if (!input || !input.dataset.optionName) return;
            updateSelectedLabel(input.dataset.optionName, input.value);
            resyncAllLabelsSoon();
        }, true);

        // Dropdown selects: change events fire normally for SELECT changes.
        productForm.addEventListener('change', function(e) {
            var target = e.target;
            if (!target || !target.matches) return;
            if (target.matches('select[data-single-option-selector]')) {
                var opt = target.options[target.selectedIndex];
                if (!opt) return;
                updateSelectedLabel(opt.dataset.optionName, target.value);
                resyncAllLabelsSoon();
            }
        });

        // T5.32e — initial sync, plus a deferred re-sync after any late
        // post-load .checked = true reshuffles (convx.js etc).
        syncAllLabelsFromCurrentState();
        requestAnimationFrame(syncAllLabelsFromCurrentState);
        setTimeout(syncAllLabelsFromCurrentState, 250);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

/* T5.39 (29 May 2026) - Keep the under-title price EXTRAS in sync with the
   selected variant: the SAVE badge (text + show/hide), the compare-price
   strikethrough visibility, and the "4 x $X" BNPL instalment. The existing
   variant-change handlers above already write the price/compare NUMBERS in ~9
   branches; rather than touch each, we observe those two elements and, whenever
   either changes, recompute the extras from the matching variant <option>'s
   data-on-sale / data-save-pct / data-instalment (rendered by Liquid, so exact
   shop money format). Single, decoupled hook = covers every selection path. */
(function () {
    function initPriceExtrasSync() {
        var priceEl = document.querySelector('.convx__product-price');
        var select = document.querySelector('select[name="id"].variant-id') || document.querySelector('select[name="id"]');
        if (!priceEl || !select) return;
        var compareEl = document.querySelector('.convx__product-price-compare-at');
        var badge = document.querySelector('[data-save-badge]');
        var instalmentEl = document.querySelector('[data-bnpl-instalment]');
        if (!badge && !instalmentEl && !compareEl) return;

        function selectedOption() {
            var id = new URLSearchParams(window.location.search).get('variant');
            var opt = id && select.querySelector('option[value="' + id + '"]');
            return opt || select.options[select.selectedIndex] || null;
        }

        function sync() {
            var opt = selectedOption();
            if (!opt) return;
            var onSale = opt.dataset.onSale === 'true';
            if (badge) {
                badge.textContent = onSale ? ('SAVE ' + opt.dataset.savePct + '%') : '';
                badge.classList.toggle('hide', !onSale);
            }
            if (compareEl) compareEl.classList.toggle('hide', !onSale);
            if (instalmentEl && opt.dataset.instalment) instalmentEl.textContent = opt.dataset.instalment;
        }

        var obs = new MutationObserver(sync);
        obs.observe(priceEl, { childList: true, characterData: true, subtree: true });
        if (compareEl) obs.observe(compareEl, { childList: true, characterData: true, subtree: true });
        sync();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPriceExtrasSync, { once: true });
    } else {
        initPriceExtrasSync();
    }
})();

/* LKC fix — accurate sold-out SIZE handling on the PDP. Marks each size available/unavailable
   for the current Colour + Fit/Style on load and after every change, gated on the real variant
   data-available, so sold-out sizes are crossed out and (with the CSS rule below) can't be
   clicked — which stops the "stranded-size recovery" from silently switching the pick to the
   only in-stock size. Additive; reads BOTH radio selections and the Fit/Style dropdown. */
(function () {
    var pf = document.getElementById('data-product-form');
    if (!pf) return;
    var sel = pf.querySelector('select[name="id"]');
    if (!sel) return;
    /* T5.96 (1 Jul 2026) — Cache each variant's split title + availability ONCE
       (titles/availability are server-rendered and never change at runtime), plus
       the Size radio NodeList, so lkcMarkSizes no longer re-splits every option and
       re-queries the DOM on every interaction. */
    var _variantParts = Array.from(sel.options).map(function (o) {
        return { parts: o.text.split(' / '), available: o.dataset.available === 'true' };
    });
    var _sizeRadios = pf.querySelectorAll('input[data-single-option-selector][data-option-name="Size"]');
    function lkcMarkSizes() {
        var ctx = [];
        pf.querySelectorAll('input[data-single-option-selector]:checked').forEach(function (i) {
            if (i.dataset.optionName !== 'Size') ctx.push(i.value);
        });
        pf.querySelectorAll('select[data-single-option-selector]').forEach(function (s) {
            var o = s.options[s.selectedIndex];
            if (o && o.dataset.optionName !== 'Size') ctx.push(s.value); /* Style/Fit as a dropdown */
        });
        var avail = {};
        _variantParts.forEach(function (vp) {
            if (!vp.available) return;
            if (ctx.every(function (v) { return vp.parts.indexOf(v) !== -1; })) {
                avail[vp.parts[vp.parts.length - 1]] = true; // size = last part of variant title
            }
        });
        _sizeRadios.forEach(function (r) {
            if (avail[r.value]) {
                r.classList.remove('unavailable');
                r.removeAttribute('disabled');
            } else {
                r.classList.add('unavailable');
                r.setAttribute('disabled', 'true');
            }
        });
    }
    /* T5.96 — Coalesce the click+change double-fire (a radio tap fires BOTH) into a
       single deferred pass instead of two setTimeout(0)s per interaction. */
    var _markQueued = false;
    function deferMark() {
        if (_markQueued) return;
        _markQueued = true;
        setTimeout(function () { _markQueued = false; lkcMarkSizes(); }, 0); // after the theme's variant handlers settle
    }
    pf.addEventListener('click', deferMark);
    pf.addEventListener('change', deferMark);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', lkcMarkSizes);
    } else {
        lkcMarkSizes();
    }
    setTimeout(lkcMarkSizes, 300); // catch any late variant reshuffle on load
})();
